// An ostrich, modelled facing +X: a bulky black body of plumes on very long bare
// legs, a long pale neck and a small head. Ported 1:1 from age-of-mcp's classic
// ostrich.ts, restoring its leg loop + body/neck/head/tail composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const z of [0.022, -0.022]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.008, 0.006, 0.2, 5),
      color: "#d8b890", position: [0, 0.1, z] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#2a2a2e",
      position: [0, 0.24, 0], scale: [1.2, 1.1, 1] },                // plumed body
    { geometry: new THREE.CylinderGeometry(0.01, 0.013, 0.2, 5), color: "#e0c2a0",
      position: [0.04, 0.36, 0], rotation: [0, 0, -0.35] },         // long neck
    { geometry: new THREE.IcosahedronGeometry(0.018, 0), color: "#e8cca8",
      position: [0.1, 0.45, 0] },                                    // head
    { geometry: new THREE.ConeGeometry(0.008, 0.022, 4), color: "#d8a050",
      position: [0.122, 0.448, 0], rotation: [0, 0, -Math.PI / 2] },   // beak
    { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#f4f4f0",
      position: [-0.04, 0.23, 0], scale: [0.8, 0.9, 1.1] },          // white tail plumes
  );
  return parts;
}

export const ostrich = defineModel({
  id: "ostrich",
  scale: 2.11, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Ostrich",
  tags: ["creature","ostrich","low-poly","age-of-mcp","classic"],
  summary: "Low-poly ostrich.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.13,
  fits: ["draft"],
  parts: () => partsFor(),
  animations: [],
});
